define('views/components/wallet_history/wallet_history',['require','backbone','text!templates/components/wallet_history/wallet_history.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/wallet_history/wallet_history.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'action-history-item',
        initialize: function () {
            if (this.model.get('transfer_amount') < 0 ) {
                this.$el.addClass('bg-danger-light');
            }else if (this.model.get('action_type') === 5) {
                this.$el.addClass('bg-orange'); 
            }else if(!this.model.get('action_details').products[0] ){
                this.$el.addClass('bg-warning-light'); 
            }
        }
    });
});
